export default __webpack_public_path__ + "static/media/ms-teams.a05fa7e1.svg";